import React, { useCallback, useEffect, useRef, useState } from "react";
import "../../style/css/gallery.css";
import { usePaginationAllGalleryListMutation } from "../../app/services/galleryService";
import { Link } from "react-router-dom";
import EastIcon from '@mui/icons-material/East';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const [page, setPage] = useState(1);
  const [galleryPaginationList, setGalleryPaginationList] = useState([]);
  const [description, setDescription] = useState("");
  const itemsPerPage = 3
  const [GalleryPagination] = usePaginationAllGalleryListMutation();
  const [totalCount, setTotalCount] = useState(0);
  const isFetching = useRef(false);

  // ✅ Get All Pagination
  const getAllPagination = useCallback(async (currentPage) => {
    if (isFetching.current) return;

    isFetching.current = true;
    const data = { page: currentPage, itemsPerPage, enable: 0 };
    try {
      const res = await GalleryPagination(data);
      if (res?.data?.status) {
        setTotalCount(res?.data?.data?.totalCount);
        setGalleryPaginationList(res?.data?.data?.list || []);
        if (res?.data?.data?.list?.length > 0) {
          setSelectedImage(res?.data?.data?.list[0]);
          setSelectedImageIndex(0)
          setDescription(res?.data?.data?.list[0]?.description);
        }
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      isFetching.current = false;
    }
  }, [itemsPerPage, GalleryPagination]);

  // ✅ Handle Resize

  // const handleResize = useCallback(() => {
  // if (window.innerWidth > 1300) {
  //   setItemsPerPage(3);
  // } else if
  //   (window.innerWidth > 768) {
  //   setItemsPerPage(3);
  // } else {
  //   setItemsPerPage(1);
  // }
  // }, []);

  useEffect(() => {
    const totalPage = Math.ceil(totalCount / itemsPerPage)
    if (totalPage > 0) {
      setPage(prev => {
        return prev > totalPage ? 1 : prev;
      })
    }
  }, [itemsPerPage, totalCount])
  useEffect(() => {
    const interval = setInterval(() => {
      if (selectedImageIndex === galleryPaginationList.length - 1) {
        setPage(prevPage => {
          const totalPages = Math.ceil(totalCount / itemsPerPage);
          // Handle last page correctly
          return prevPage < totalPages ? prevPage + 1 : 1;
        });
        setSelectedImage(galleryPaginationList[0]);
        setSelectedImageIndex(0);
      }
      else {
        setSelectedImage(galleryPaginationList[selectedImageIndex + 1]);
        setSelectedImageIndex(selectedImageIndex + 1);
      }
    }, 3000);

    return () => clearInterval(interval);
  }, [totalCount, itemsPerPage, galleryPaginationList, selectedImageIndex]);

  // useEffect(() => {
  //   const resizeHandler = () => {
  //     clearTimeout(window.resizeTimer);
  //     window.resizeTimer = setTimeout(() => {
  //       handleResize();
  //     }, 100); // Adjust debounce delay if needed
  //   };

  //   window.addEventListener('resize', resizeHandler);
  //   handleResize(); // On mount
  //   return () => window.removeEventListener('resize', resizeHandler);
  // }, [handleResize]);



  // useEffect(() => {
  //   window.addEventListener('resize', handleResize);
  //   handleResize(); // On mount
  //   return () => window.removeEventListener('resize', handleResize);
  // }, [handleResize]);

  // ✅ Pagination Handlers
  const handleNextPage = async () => {
    if (page * itemsPerPage < totalCount) {
      setPage((prev) => prev + 1);
    }
  };

  const handlePrevPage = async () => {
    if (page > 1) {
      setPage((prev) => prev - 1);
    }
  };

  useEffect(() => {
    getAllPagination(page);
  }, [page, getAllPagination]);

  // ✅ Handle Image Click
  const handleImageClick = (item, description, e, index) => {
    e.stopPropagation();
    setSelectedImage(item);
    setSelectedImageIndex(index)
    setDescription(description);
  };

  // ✅ Render
  return (
    <div className="gallery-wrap-container p-md-5 p-3 overallPadding">
      {galleryPaginationList.length > 0 && (
        <>
          <div className="d-flex justify-content-between align-items-center">
            <h2 className="custom-header title-font">Our Galleries</h2>
            <div className="d-flex align-items-center">
              <p className="viewAllEvents mb-0">
                <Link to="/view-Gallery" className="commonColor title-font">
                  View All <EastIcon />
                </Link>
                <ArrowBackIosIcon
                  onClick={handlePrevPage}
                  className={`ms-1 arrowConfig ${page === 1 ? 'disable-prev' : ''}`}
                />
                <ArrowForwardIosIcon
                  onClick={handleNextPage}
                  className={`ms-1 arrowConfig ${page * itemsPerPage >= totalCount ? 'disable-prev' : ''}`}
                />
              </p>
            </div>
          </div>
          <div className="row w-100 mx-auto">
            <div className={`${totalCount > 3 ? 'col-md-9' : 'col-md-12'} col-12 p-0`}>
              {selectedImage && (
                <div className="d-flex justify-content-center h-100">
                  <img
                    src={selectedImage?.imageUrl}
                    alt="Selected"
                    className="selected-image w-100"
                  />
                  <p className="img-description fs-4 fw-bold w-50">{description}</p>
                </div>
              )}
            </div>
            <div className={`col-md-3 col-12 ${totalCount > 3 ? "d-md-block d-none" : "d-none"} pe-0`}>
              <div className="slider-gallery w-100 d-flex flex-wrap flex-md-column flex-row align-items-end row-gap-3">
                {galleryPaginationList.map((item, index) => (
                  <div className="slider p-0  " key={index}>
                    <img
                      src={item?.imageUrl}
                      alt="Gallery"
                      className={`galleryImg ${selectedImage?._id === item?._id ? "active" : ""} w-100`}
                      onClick={(e) => handleImageClick(item, item?.description, e, index)}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

        </>
      )}
    </div>
  );
};

export default Gallery;
